import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

import Icon from '../../../../components/ui/Icon/Icon'
import PreferenceForm from '../../../../components/home/PreferenceForm/PreferenceForm'
import AccessibleForm from '../../../../components/accessibility/AccessibleForm/AccessibleForm'
import LoadingBase from '../../../../components/loading/LoadingBase/LoadingBase'

import MoreHeaderParticles from '../../../../assets/img/more-header-particles.svg'

import * as PreferenceApiService from '../../../../services/api/requests/Preferences'

import { MAIN, SETTINGS } from '../../../../services/data/profilePages.json'

const MainPage = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
`

const Header = styled.div`
  position: relative;
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  min-height: 87px;
  font-size: 0.7rem;
  background: var(--color-primary);

  &::before {
    content: ' ';
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: url('${MoreHeaderParticles}');
    background-repeat: no-repeat;
    background-position: right top;
  }
`

const ReturnIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 0.92rem;
  margin-left: 20px !important;
  margin-right: 20px !important;
  color: var(--color-fg-light);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;

  & > svg {
    position: relative;
    color: #ffffff;
  }
`

const Title = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  flex: 1;
  padding: 20px 0;
  margin: 0;
  margin-right: 60px;
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  text-transform: uppercase;
  text-align: center;
`

const Content = styled.div`
  padding: 2rem 1.1875rem;
  overflow: auto;
`

class ManagePreferencesPage extends React.Component {
  state = {
    selectedPreferences: [],
    basePreferences: [],
    loadingStatus: null,
    submitStatus: null,
    errorMessage: null,
  }

  componentDidMount() {
    this.getBasePreferences()
  }

  handleSubmit = async (values, state) => {
    const { accessToken, setProfileModalPage, setPreferenceIds } = this.props

    state.setSubmitting(true)

    const { preferences } = values
    const selectedPreferences = preferences
      .map((pref, index) => (pref ? index : ''))
      .filter(pref => pref)

    try {
      await PreferenceApiService.postPreferences(
        {
          ids: selectedPreferences,
        },
        { accessToken },
      )

      // ST-3117 save preferences in primaryInfo
      setPreferenceIds(selectedPreferences)

      if (setProfileModalPage) {
        setProfileModalPage(MAIN)
      }
    } catch (error) {
      const { data = {}, status } = error.response || {}
      const { message = 'Network Error' } = data || {}

      state.setStatus({
        status,
        error: message,
      })
    }
    state.setSubmitting(false)
  }

  getBasePreferences = async () => {
    this.setState({
      loadingStatus: 0,
    })

    const { accessToken, setPreferenceIds } = this.props

    try {
      const preferencesResponse = await PreferenceApiService.getPreferences()

      try {
        const selectedIds = []
        const selectedResponse = await PreferenceApiService.getSelectedPreferences(
          accessToken,
        )

        selectedResponse.data.ids.forEach(value => {
          selectedIds[value] = true
        })

        setPreferenceIds(selectedResponse.data.ids)

        this.setState({
          loadingStatus: 1,
          selectedPreferences: selectedIds,
          basePreferences: preferencesResponse.data,
        })
      } catch (e) {
        this.setState({
          loadingStatus: 4,
          errorMessage: 'Unable to Load Selected Preferences',
        })
      }
    } catch (e) {
      this.setState({
        loadingStatus: 4,
        errorMessage: 'Unable to Load Base Preferences',
      })
    }
  }

  render() {
    const { basePreferences, loadingStatus, selectedPreferences } = this.state
    const { setProfileModalPage } = this.props

    return (
      <MainPage>
        <Header>
          <ReturnIcon onClick={() => setProfileModalPage(SETTINGS)}>
            <Icon name="slide-left" />
          </ReturnIcon>

          <Title>Manage Preferences</Title>
        </Header>
        <Content>
          {loadingStatus === 0 && <LoadingBase />}
          {loadingStatus === 1 && (
            <AccessibleForm
              initialValues={{ preferences: selectedPreferences }}
              onSubmit={this.handleSubmit}
              component={PreferenceForm}
              componentProps={{
                buttonLabel: 'Update',
                basePreferences,
              }}
              action="/a/register/preferences"
            />
          )}
        </Content>
      </MainPage>
    )
  }
}

ManagePreferencesPage.defaultProps = {
  setProfileModalPage: () => {},
  primaryInfo: {},
}

ManagePreferencesPage.propTypes = {
  setProfileModalPage: PropTypes.func,
  primaryInfo: PropTypes.object,
}

export default ManagePreferencesPage
